'use client';
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@/components/ui/dialog';
import { useEffect, useState } from 'react';
import i18n from '../../i18n';

import { Separator } from '@/components/ui/separator.tsx';
import { TranslateIcon } from '@phosphor-icons/react';
import dayjs from 'dayjs';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/it';
import 'dayjs/locale/ja';
import 'dayjs/locale/pt';
import 'dayjs/locale/ru';
import LocaleData from 'dayjs/plugin/localeData.js';
import LocalizedFormat from 'dayjs/plugin/localizedFormat.js';
import { availableLanguages } from 'lib/utils';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useTranslation } from 'react-i18next';

dayjs.extend(LocalizedFormat);
dayjs.extend(LocaleData);
dayjs.locale(i18n.language?.substring(0, 2) || 'en');

export default function LanguageButton() {
	const [routeTranslations, setRouteTranslations] = useState([]);
	const [t] = useTranslation();

	const pathname = usePathname();
	const searchParams = useSearchParams();

	const data = availableLanguages;

	const router = useRouter();

	const getRouteTranslations = async () => {
		const response = await fetch(
			process.env.API_URL + 'v1/glob/route_translations'
		);
		const result = await response.json();
		if (result.routeTranslations) {
			setRouteTranslations(result.routeTranslations);
		}
	};

	function translatePathname(pathname, language, fromLanguage) {
		return pathname
			.split('/')
			.map((segment: string, index: number) => {
				if (index == 1) {
					const supportedLanguage = availableLanguages.find((lang) => {
						return lang.lang_iso_code == segment;
					});
					if (supportedLanguage) {
						return language;
					}
				}
				console.log('checkTranslation', language, fromLanguage);
				const translation = routeTranslations.find((entry) => {
					return entry[fromLanguage] == segment;
				});
				if (translation) {
					return translation[language];
				} else {
					return segment;
				}
			})
			.join('/');
	}

	const changeLanguageOnClick = (language) => {
		const fromLanguage = i18n.language;
		i18n.changeLanguage(language);
		dayjs.locale(language);
		document.cookie = `NEXT_LOCALE=${language}; path=/; max-age=31536000`;

		const translatedPath = translatePathname(pathname, language, fromLanguage);

		router.push(`${translatedPath}?${searchParams?.toString()}`);
	};

	useEffect(() => {
		getRouteTranslations();
	}, []);

	if (!data) {
		return null;
	}

	return (
		<Dialog>
			<form>
				<DialogTrigger asChild>
					<button className='cursor-pointer hover:text-blue-300'>
						<TranslateIcon size={32} />
					</button>
				</DialogTrigger>
				<DialogContent className='sm:max-w-[425px] text-[#414141]'>
					<DialogHeader>
						<DialogTitle className='text-2xl'>
							{t('impfschaeden.erfassen.sprachauswahl')}
						</DialogTitle>
						<Separator />
					</DialogHeader>
					<div className='grid grid-cols-2 gap-4'>
						{availableLanguages.map((language) => {
							return (
								<DialogClose asChild key={language.lang_iso_code}>
									<button
										onClick={() =>
											changeLanguageOnClick(language.lang_iso_code)
										}
									>
										<div className='flex items-end cursor-pointer'>
											<div className='flex flex-col place-content-end items-end px-1 pt-1 h-8 w-16 border-3 border-gray-600 rounded-md'>
												{language.lang_iso_code}
											</div>
											<div className='flex flex-col leading-4 items-start ms-2 '>
												<div className='text-sm text-gray-600'>
													{language.lang_name_de}
												</div>
												<div className='text-xs text-black'>
													{language.lang_name}
												</div>
											</div>
										</div>
									</button>
								</DialogClose>
							);
						})}
					</div>
				</DialogContent>
			</form>
		</Dialog>
	);
}
